import {Component, OnInit, OnDestroy} from '@angular/core';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "@amlCore/utils";
import {RegistriesService} from "../../service";
import {TableService, VisitedService} from "@amlCore/services";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {TerroristSubject} from "../../model";

@Component({
  selector: 'app-registry-terrorist-list',
  templateUrl: './terroristList.component.html'
})
export class TerroristListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  $destroy = new Subject();

  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, route, visitedService, tableService, {pageSize: 20, sort: 'name', dir: 'ASC'});
  }

  private id: string;
  public isAll = false; // поиск по всем перечням
  public terroristList: Array<TerroristSubject> = [];

  public goBack = Utils.goBack;

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.id === undefined) {
      this.isAll = true;
    }

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.$destroy))
      .subscribe(data => {
        const params = this.syncParams(data);
        params.id = this.id;
        this.loadList(params);
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params) {
    const filter = this.getParams({...params, ...this.filter});
    this.navigate(filter);
  }

  // @ovveride
  public onSearch() {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  private loadList(params?: any) {
    this.regSrv.getTerroristList(this.getParams(params))
      .pipe(takeUntil(this.$destroy))
      .subscribe(data => {
        this.initIdsMap(data);
        this.terroristList = data.content;
        this.total = data.totalSize;
    });
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  getIdOfBase(item: TerroristSubject): string {
    return item.base ? item.id : item.parentId;
  }

}
